







import Vue from 'vue'
import { Component, Mixin, Lifecycle, Prop, p } from 'av-ts'
import { EventBus } from '@/eventbus'
import 'firebaseui/dist/firebaseui.css'

import Firestore from '@/firestore'

@Component()
export default class Auth extends Mixin(EventBus) {
  @Lifecycle
  mounted() {
    Firestore.mountUI('#firebaseui-auth-container')
  }
}
